import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

export interface ErrorCardExplicitData {
  message: string;
  detail?: unknown;
}

@Component({
    selector: 'app-error-card-explicit',
    templateUrl: './error-card-explicit.component.html',
    styleUrls: ['./error-card-explicit.component.scss'],
    standalone: false
})
export class ErrorCardExplicitComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<ErrorCardExplicitComponent>, @Inject(MAT_DIALOG_DATA) public data: ErrorCardExplicitData) { }

  ngOnInit() {
  }

  public refresh() {
    window.location.reload();
  }

}
